import { twMerge } from 'tailwind-merge';
import { clsx, type ClassValue } from 'clsx';
import dayjs from 'dayjs';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const formatTime = (time: string) =>
  time === '--:--' ? '--:--' : dayjs(`1970-01-01T${time}`).format('h:mm A');

export const formatMinutes = (min: number): string => {
  if (min === 0) return '0h';
  const h = Math.floor(min / 60);
  const m = min % 60;
  return m === 0 ? `${h}h` : `${h}h ${m}m`;
};

export const getColorForText = (text: string, colors: string[]): string => {
  let h = 0;
  for (let i = 0; i < text.length; i++) h = text.charCodeAt(i) + ((h << 5) - h);
  return colors[Math.abs(h) % colors.length];
};